module.exports = __webpack_public_path__ + "static/media/page-header-bk.118275c1.jpg";